var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('main-div',{scopedSlots:_vm._u([{key:"main",fn:function(){return [_c('student-header-navigation',{attrs:{"title":"ダッシュボード"}}),(_vm.isCo)?_c('co-dash-board'):_c('da-dash-board')]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }